import React from 'react'
import ErpBody from '../components/erp/ErpBody';
import Footer from '../components/shared/Footer';
import Navbar from '../components/shared/Navbar';

const ERPDevelopment = () => {
  return (
    <div>
      <Navbar></Navbar>
      <ErpBody></ErpBody>
      <Footer></Footer>
    </div>
  )
}

export default ERPDevelopment;
